import { render, staticRenderFns } from "./manage-plan-change.vue?vue&type=template&id=2afd14a0&scoped=true"
import script from "./manage-plan-change.vue?vue&type=script&lang=js"
export * from "./manage-plan-change.vue?vue&type=script&lang=js"
import style0 from "./manage-plan-change.vue?vue&type=style&index=0&id=2afd14a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd14a0",
  null
  
)

export default component.exports